import { render } from "./ViajesPublicados.vue?vue&type=template&id=55ba4412&scoped=true"
import script from "./ViajesPublicados.vue?vue&type=script&lang=js"
export * from "./ViajesPublicados.vue?vue&type=script&lang=js"

import "./ViajesPublicados.vue?vue&type=style&index=0&id=55ba4412&scoped=true&lang=css"
import "./ViajesPublicados.vue?vue&type=style&index=1&id=55ba4412&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ba4412"]])

export default __exports__